import cloneDeep from 'lodash/cloneDeep';

const merge = (base, ...extensions) => {
  const mergedMetadata = base;

  extensions.forEach(({ toRemove, ...extension }) => {
    if (toRemove && toRemove.length) {
      const arrayKey = ['tabs', 'groups', 'fields'].find((key) => {
        return mergedMetadata[key];
      });

      if (arrayKey) {
        const targetArray = mergedMetadata[arrayKey];

        mergedMetadata[arrayKey] = targetArray.filter(
          ({ name }) => !toRemove.includes(name),
        );
      }
    }

    Object.entries(extension).forEach(([key, value]) => {
      if (
        ['tabs', 'groups', 'fields'].includes(key) &&
        Array.isArray(mergedMetadata[key])
      ) {
        const sourceArray = mergedMetadata[key];

        value.forEach(({ position, before, after, ...item }) => {
          let idxToAdd = sourceArray.length;

          const existingItemIndex = sourceArray.findIndex(
            ({ name }) => name === item.name,
          );

          if (existingItemIndex !== -1) {
            // eslint-disable-next-line no-param-reassign
            item = merge(sourceArray[existingItemIndex], item);

            sourceArray.splice(existingItemIndex, 1); // delete existing item
            idxToAdd = existingItemIndex;
          }

          if (typeof position !== 'undefined') {
            idxToAdd = position;
          } else if (before) {
            idxToAdd = sourceArray.findIndex(({ name }) => name === before);
          } else if (after) {
            idxToAdd = sourceArray.findIndex(({ name }) => name === after) + 1;
          }

          sourceArray.splice(idxToAdd, 0, item);
        });
      } else {
        const newValue = value ?? mergedMetadata[key];

        if (typeof newValue !== 'undefined') {
          mergedMetadata[key] = newValue;
        }
      }
    });
  });

  return mergedMetadata;
};

const getMetadataList = ({ extends: extendedMetadata, ...metadata }) => {
  if (extendedMetadata) {
    if (Array.isArray(extendedMetadata)) {
      // supports an Array of extends
      return [...extendedMetadata.map(getMetadataList).flat(), metadata];
    }

    // most specific ones come first cause they'll be extended
    return [...getMetadataList(extendedMetadata), metadata];
  }

  return [metadata];
};

export default (mainMetadata) => {
  // using loadash's cloneDeep since the cloneObject helper erases regexes inside the structure
  const metadataList = getMetadataList(cloneDeep(mainMetadata));
  const baseMetadata = {};
  const merged = merge(baseMetadata, ...metadataList);

  // procura pelo grupo de "visibilidade" e o coloca como último da lista
  const contentGroup = merged.tabs[0].groups;

  if (contentGroup) {
    const visibilityPosition = contentGroup.findIndex(
      ({ name }) => name === 'visibility',
    );

    if (visibilityPosition !== -1) {
      const objectToMove = contentGroup.splice(visibilityPosition, 1)[0];
      contentGroup.push(objectToMove);
    }
  }

  return merged;
};
